/** MUI */
import {
  Box,
  Container,
  Grid2 as Grid,
  Link,
  Typography,
} from "@mui/material";

/** Components */
import classes from "./terms.module.css";

const Terms = () => {
  return (
    <Box className={classes.featuresCustomer}>
      <Container
        maxWidth="xl"
        disableGutters
        className={classes.containerFeat}
      >
        <Grid container spacing={{ xs: 2, xxl: 6 }}>
          <Grid size={{ xs: 12 }}>
            <Box className={classes.subcontent} textAlign="justify">
              <Box className={classes.subcontent2}>
                <ol type="I">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Engagement
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Terms</strong>. These Terms and Conditions (“
                      <strong>Terms</strong>”) control the rights and
                      obligations of all customers (“<strong>Customer</strong>”
                      or “<strong>Customers</strong>”) in their use of Noddok (“
                      <strong>Noddok</strong>”), including any users thereof.
                      The Terms are a binding contract and thus mandatory,
                      unwaivable, enforceable and applicable to each Customer in
                      any territory from which they access and use Noddok. It is
                      the Customers’ sole responsibility to carefully and
                      comprehensively read, understand and execute the Terms
                      prior to any access or use, and before incurring any
                      charges. By accepting the Terms, Customer engages the
                      Company in order to use the Features in Sections IV, V, VI
                      and VII hereto.
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Ownership. </strong>Noddok is a proprietary
                      software wholly owned, developed, maintained and
                      distributed by Kiiper Inc., a Delaware corporation (“
                      <strong>Company</strong>”).
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Effective Date</strong>.<strong> </strong>These
                      Terms, along with any updated versions, will become
                      effective for the Customer on the date Customer accepts
                      them by checking the box next to the consent statement,
                      which reads: "I have read and agreed to the{" "}
                      <strong>
                        <Typography
                          fontWeight={600}
                          sx={{ textDecoration: "underline" }}
                          component="span"
                        >
                          Terms and Conditions of Service
                        </Typography>
                      </strong>{" "}
                      and the{" "}
                      <strong>
                        <Typography
                          fontWeight={600}
                          sx={{ textDecoration: "underline" }}
                          component="span"
                        >
                          Privacy Policy
                        </Typography>
                      </strong>
                      ." Customer will not have access to or be able to use
                      Noddok until they have unequivocally accepted these Terms.
                    </li>
                  </ol>
                  <ol start="4">
                    <li class="ListParagraph">
                      <strong>Partners</strong>. Participation in the partner
                      program is subject to the{" "}
                      <Link href="/additional-terms" fontWeight={600}>additional partner terms</Link>.
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="2">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      License{" "}
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Use</strong>. Subject to Customer’s acceptance of
                      the Terms and payment of the fees under Section VIII
                      hereto, Customer is granted a limited, temporary,
                      non-exclusive, non-distributable and fundamentally
                      rescindable and modifiable license to use Noddok (the “
                      <strong>License</strong>”). The License permits Customer
                      solely to take all necessary steps to use Noddok via the
                      Internet, on any browser and any device, and only to the
                      extent Customer has initiated a free trial or activated a
                      Plan under these Terms.
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Limitations. </strong>Customer will not: (i)
                      permit any access to, use or management of Customer’s
                      profile or users on Noddok whatsoever to any
                      non-authorized person, agent, employee, affiliate or
                      others of any non-authorized third party; (ii) distribute,
                      divulge, resell, lease or loan this License. No rights,
                      Features or privileges are impliedly granted in addition
                      to those accorded under the License.
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Content</strong>. Customer may upload, store or
                      otherwise make available any data, documents or materials
                      into Noddok as a result of its use (“
                      <strong>Content</strong>”). Customer will not use Noddok
                      to upload, store, transmit, generate or otherwise make
                      available any illegal, fraudulent, defamatory, obscene,
                      pornographic, profane, threatening, abusive, hateful,
                      harassing, offensive, inappropriate, objectionable, false
                      and/or misleading information or communications of any
                      kind into Noddok, nor will Customer introduce any computer
                      virus or harmful data into Noddok. Noddok is not to be
                      held liable for any damages resulting from Customer’s
                      upload of the Content even if it takes appropriate steps
                      to ensure the monitoring and removal of any potentially
                      inappropriate Content.
                    </li>
                  </ol>
                  <ol start="4">
                    <li>
                      <strong>IP Rights</strong>. In accordance with Section
                      I(2) of the Terms, Customer hereby fully, clearly and
                      irrevocably recognizes and represents to acknowledge, to
                      the fullest extent permitted by law, Company’s full
                      ownership of any and all Plans, Features, creations,
                      codes, source codes, software, automations, derivatives,
                      designs, feedback, marks and other industrial, proprietary
                      and intellectual property rights that arise out from,
                      relate or pertain to, and are in connection with, Noddok
                      (“<strong>IP Rights</strong>”). Customer further fully,
                      clearly and irrevocably renounces and/or reassigns any
                      rights on Noddok to Company, and to the extent such rights
                      are not subject to renunciation or reassignment as a
                      matter of law, Customer hereby grants a perpetual,
                      worldwide, fully transferable, sublicensable,
                      non-revocable, fully paid-up, royalty free license to use
                      said rights Customer provides to Company in any way.
                      Disassembly, decompilation or reverse engineering and
                      other source code derivation of Noddok is prohibited.
                      Customer does not own any of the Company’s IP Rights, and
                      has no right to remove any of the Company’s trademarks,
                      proprietary marks, copyright is notices and other
                      indication of the former’s ownership of Noddok.
                    </li>
                  </ol>
                  <ol start="5">
                    <li>
                      <strong>Revocation</strong>. The License will be
                      automatically revoked at an account level when such is set
                      as “Inactive” under Section III(3) of these Terms. If
                      Customer has no account with an “Active” status under
                      Section III(3) herein, the License will be deemed revoked
                      as to the subscription.
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="3">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Subscription and Account(s)
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Subscription</strong>.
                      <span>
                        {" "}
                        Customer will manage all administrative matters, as well
                        as creating and managing accounts and their access
                        levels, through their Subscription, which will be
                        established upon signing up for Noddok (“
                        <strong>Subscription</strong>”).
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Account</strong>.{" "}
                      <span>
                        Customer may have multiple accounts in its Subscription
                        (“<strong>Account</strong>” or “
                        <strong>Accounts</strong>”). Each Account will have
                        separate Plans, Features and fees accordingly. The
                        Accounts will be assigned a status in accordance with
                        Section III(3) herein.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Account Status</strong>
                      <span>
                        . Each Account status will determine Customer’s current
                        access to, and use of, Noddok.
                      </span>
                    </li>
                  </ol>
                  <Box ml={3}>
                    <ol class="awlist1">
                      <li type="a">
                        <strong>Free Trial</strong>
                        <span>
                          . Customer’s Account during a free trial under Section
                          V hereto will be designated as such, and will have
                          access to the Features available under a free trial of
                          Noddok. A free trial will expire when Customer
                          exhausts the pages available under the free trial or
                          upon expiration of the 14-day period to use said
                          number of pages, whichever occurs first. Customer may
                          change its Free Trial Account status by activating a
                          monthly Plan.{" "}
                        </span>
                      </li>
                    </ol>
                    <ol start="2" type="a">
                      <li class="ListParagraph">
                        <strong>On-Hold</strong>.{" "}
                        <span>
                          Customer’s Account will be put on an on-hold status
                          for up to 30 days when Customer’s free trial has
                          expired. Customer may change its Subscription status
                          from on-hold by activating a monthly Plan.{" "}
                        </span>
                      </li>
                    </ol>
                    <ol start="3" type="a">
                      <li class="ListParagraph">
                        <strong>Active</strong>.{" "}
                        <span>
                          Customer’s Account will be assigned an “Active” status
                          so long as Customer has an active Plan –as defined in
                          Section VII hereto- and will be thus able to access
                          the Features available under the selected Plan.{" "}
                        </span>
                      </li>
                    </ol>
                    <ol start="4" type="a">
                      <li>
                        <strong>Inactive</strong>.{" "}
                        <span>
                          Customer’s Account will be assigned an "Inactive"
                          status if the on-hold period expires, or if the
                          Customer deactivates their Plan, in which case they
                          will be able to access and use Plan Features until the
                          Account’s anniversary date, after which their access
                          will be terminated and Features will expire.{" "}
                        </span>
                      </li>
                    </ol>
                    <Box ml={3}>
                      <ol class="awlist5">
                        <li>
                          <strong>Contingency Access</strong>.{" "}
                          <span>
                            Exceptionally, Customer may request Noddok, by and
                            through its customer support team, to permit access
                            to an Account for up to three (3) business days for
                            the limited purpose of downloading any data in the
                            Account, in which period Customer will not have the
                            ability to use Noddok unless a Plan is activated.{" "}
                          </span>
                        </li>
                      </ol>
                    </Box>
                  </Box>
                  <ol start="4" class="awlist6">
                    <li>
                      <strong>Grace Period</strong>.{" "}
                      <span>
                        Where fees for an Account have not been processed under
                        Section VIII(10), Customer’s Account will enter a 30-day
                        grace period. During this grace period, Customer may
                        continue to utilize any remaining Features from the
                        previous billing period, but will not be able to renew
                        the monthly Plan and the Features thereof until payment
                        is processed.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="4">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Product &amp; Features
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Product</strong>.{" "}
                      <span>
                        Noddok processes documents and transactions from
                        integrated systems, business workflows, or manual
                        uploads, and provides output in the form of files
                        compatible with Customer’s system, or automated entries
                        into an integrated system.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Documents and Transactions</strong>.{" "}
                      <span>
                        Customer may input documents for Noddok to process. Such
                        documents may include, without limitation, bank
                        statements, checks, invoices, bills, payments, reports,
                        and any other document that Noddok admits or processes
                        (“<strong>Document</strong>” or “
                        <strong>Documents”</strong>). Noddok shall also process
                        transactions automatically received from Customer’s
                        integrated system (“<strong>Transactions</strong>”).
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Integrated systems</strong>.{" "}
                      <span>
                        Noddok supports systems’ integrations, including but not
                        limited to Quickbooks and Xero. An Account in Noddok
                        must be linked to only one subscription in the
                        integrated system.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li>
                      <strong>Unlimited users; Profiles</strong>.{" "}
                      <span>
                        {" "}
                        Customer may create and manage users (“
                        <strong>User</strong>” or “<strong>Users</strong>”), as
                        well as manage its access levels based on predefined
                        profiles.
                      </span>
                    </li>
                  </ol>
                  <Box ml={3}>
                    <ol type="a">
                      <li>
                        <strong>Owner</strong>. An owner User holds the highest
                        level of privileges in a Subscription (“
                        <strong>Owner</strong>”). The Owner may perform all
                        actions in a Subscription which include, without
                        limitation, transfer ownership, manage and change
                        payment methods, create and manage Accounts, activate
                        and change monthly Plans, manage Users, manage Documents
                        and Transactions, among others.
                      </li>
                    </ol>
                    <ol start="2" type="a">
                      <li>
                        <strong>Administrator</strong>. Administrator users are
                        second to Owner in privileges (“
                        <strong>Administrator</strong>” or “
                        <strong>Administrators</strong>”). Administrators may
                        create and manage Accounts, activate and change monthly
                        Plans, manage Users, manage Documents and Transactions,
                        among others.
                      </li>
                    </ol>
                    <ol start="3" type="a">
                      <li>
                        <strong>Standard</strong>. Standard users access Noddok
                        at an operative level (“<strong>Standard</strong>” or “
                        <strong>Standards</strong>”). Standards may only manage
                        Documents and Transactions.
                      </li>
                    </ol>
                  </Box>
                  <ol start="5">
                    <li class="ListParagraph">
                      <strong>Unlimited storage</strong>.{" "}
                      <span>
                        Without prejudice to Section III(2.4) of these Terms,
                        Noddok will provide unlimited storage of Customer’s
                        uploaded Documents and Transactions.
                      </span>
                    </li>
                  </ol>
                  <ol start="6">
                    <li>
                      <strong>Processing pricing</strong>.{" "}
                      <span>
                        Pricing for processing Documents and Transactions will
                        be expressed in pages (“<strong>Pages</strong>”).
                        Processing pricing are posted on Noddok’s website, and
                        may be modified at any time.
                      </span>
                    </li>
                  </ol>
                  <ol start="7">
                    <li>
                      <strong>Customer support</strong>.{" "}
                      <span>
                        A customer support team will provide assistance to
                        Customer in its use of Noddok. Different levels of
                        customer support will be provided in accordance with
                        Customer’s selected Plan, which may include standard or
                        personalized onboarding, varied communications channels,
                        and people from Noddok’s team.
                      </span>
                      <span>&#xa0; </span>
                    </li>
                  </ol>
                  <ol start="8">
                    <li>
                      <strong>Product updates</strong>.{" "}
                      <span>
                        Subject to Customer’s Plan, Noddok may provide Customer
                        with priority access to new product developments,
                        features or updates.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="9">
                    <li class="ListParagraph">
                      <strong>Roll over period</strong>.{" "}
                      <span>
                        If at the end of a billing period Customer has an unused
                        number of Pages available under their Plan, said Pages
                        will roll over to the next billing periods in accordance
                        with Customer’s Plan, as defined in Section V of these
                        Terms.
                      </span>
                    </li>
                  </ol>
                  <ol start="10">
                    <li class="ListParagraph">
                      <strong>Records Retention Policy</strong>.{" "}
                      <span>
                        Noddok will permanently store Customer’s Documents,
                        Transactions, and generally any Content in the Account,
                        which will remain available after an Account is set as
                        “Inactive” under Section III(2.4).
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="5">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Free trial{" "}
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Free trial</strong>.{" "}
                      <span>
                        Customer may access a single free trial of Noddok,
                        subject to the terms set forth on Noddok's website,
                        which may be revised and updated at any time.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Unused Pages</strong>.{" "}
                      <span>
                        If Customer activates a Plan during the free trial, any
                        available Pages will carry over and be credited along
                        with the Pages included under the selected Plan,
                        starting from the Subscription's anniversary date and
                        subject to the roll-over period..
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="6">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Plans
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li class="ListParagraph">
                      <strong>Plans</strong>.{" "}
                      <span>
                        Customer may activate a monthly Plan for each Account ("
                      </span>
                      Plan<span>" or "</span>Plans
                      <span>
                        "). For initial activation, Customer shall receive the
                        Pages and access the Features under the selected Plan.
                        Plans are posted on Noddok’s app and may be subject to
                        periodical updates.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li class="ListParagraph">
                      <strong>Subscription’s anniversary date</strong>.{" "}
                      <span>
                        The anniversary date for the Subscription is defined by
                        the date the first Plan for an Account was activated.
                        The anniversary date of Plans activated on February 29
                        or the 31
                      </span>
                      <span>
                        <sup>st</sup>
                      </span>
                      <span> day of each month will be set on the 1</span>
                      <span>
                        <sup>st</sup>
                      </span>
                      <span> day of the month. </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li class="ListParagraph">
                      <strong>Fees</strong>.{" "}
                      <span>
                        Plans have assigned fees, payable in accordance with
                        Section VII.
                      </span>{" "}
                      <span>
                        Fees are posted on Noddok’s app and do not include
                        payable taxes. Customer shall pay the fees for the
                        selected Plan of each Account within their Subscription.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li class="ListParagraph">
                      <strong>Features</strong>.{" "}
                      <span>
                        Each Plan has a specific variety of Features defined by
                        Noddok, which are indicated in Section IV of these Terms
                        (“<strong>Feature</strong>” or “
                        <strong>Features</strong>”).
                      </span>
                    </li>
                  </ol>
                  <ol start="5">
                    <li class="ListParagraph">
                      <strong>Successive Activations</strong>.{" "}
                      <span>
                        For activation of Plans for successive Accounts,
                        Customer may choose between two options: (i) receive the
                        in number of Pages based on the activated Plan and
                        billed accordingly; or (ii) receive a prorated number of
                        Pages based on the remaining days until the
                        Subscription’s anniversary date, and be billed the
                        prorated pricing with respect to the activated Plan.
                      </span>
                      <span>&#xa0; </span>
                      <span>
                        In both cases, fees in accordance with Customer’s
                        selected option will be applied to Customer’s payment
                        method.
                      </span>
                      <span>&#xa0; </span>
                    </li>
                  </ol>
                  <ol start="6">
                    <li class="ListParagraph">
                      <strong>Renewal</strong>.{" "}
                      <span>
                        Plans for Accounts will be renewed automatically on a
                        monthly basis, on the Subscription’s anniversary date,
                        as defined in Section VI(2).
                      </span>
                    </li>
                  </ol>
                  <ol start="7">
                    <li class="ListParagraph">
                      <strong>Upgrade</strong>.{" "}
                      <span>
                        Customer may upgrade an existing Plan for an Account at
                        any time. In upgrading a Plan, Customer may choose
                        between two options: (i) receive the difference in
                        number of Pages based on, and be billed the pricing
                        difference with respect to, the activated Plan; or (ii)
                        receive a number of prorated difference of Pages based
                        on the remaining days until the Subscription’s
                        anniversary date, and be billed the prorated pricing
                        difference with respect to the activated Plan.
                      </span>
                      <span>&#xa0; </span>
                      <span>
                        In both cases, fees in accordance with Customer’s
                        selected option will be applied to Customer’s payment
                        method.
                      </span>
                    </li>
                  </ol>
                  <ol start="8">
                    <li class="ListParagraph">
                      <strong>Downgrade</strong>.{" "}
                      <span>
                        Customer may downgrade an Account’s current Plan at any
                        time. In this case, the Account’s current Plan, its
                        Pages, Features and fees will remain effective until the
                        end of the current billing period. The Plan downgrade
                        will be effective, and fees will be adjusted, in the
                        next billing period.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="9">
                    <li class="ListParagraph">
                      <strong>Deactivation</strong>.{" "}
                      <span>
                        Customer may deactivate an Account’s active Plan at any
                        time. The deactivation will be effective after the end
                        the current billing period, after which Customer’s
                        Account will be set as “Inactive” under Section
                        III(2.4).
                      </span>
                    </li>
                  </ol>
                  <ol start="10">
                    <li class="ListParagraph">
                      <strong>Fees updates</strong>.{" "}
                      <span>
                        Fees for Plans may, upon prior notice to Customer, be
                        revised and updated by Company at any time. Unless
                        otherwise determined by the Company, the revised fees
                        will be effective in the next Plan activation and/or
                        billing period.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="7">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Payment of Fees
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Conditions</strong>.{" "}
                      <span>
                        Fees shall be paid with Customer’s selected payment
                        method. Customer will be billed in advance, less
                        discounts plus taxes.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Stripe</strong>.{" "}
                      <span>
                        For payments with credit or debit cards, Noddok uses
                        Stripe, an independent third-party payment services
                        provider.
                      </span>
                    </li>
                  </ol>
                  <Box ml={3}>
                    <ol class="awlist7" type="a">
                      <li>
                        <strong>Card Data Collection</strong>.{" "}
                        <span>
                          Stripe may collect, store and save Customer's credit
                          or debit card information at Customer's request. To
                          the extent Customer saves its card information on
                          Stripe, any of Customer's saved card information may
                          display on Stripe when Customer attempts to process
                          payment. Noddok and Company will not store, save,
                          copy, reproduce or have reproduced any card
                          information introduced by Customer on Stripe.
                        </span>
                      </li>
                    </ol>
                    <ol start="2" class="awlist8" type="a">
                      <li>
                        <strong>Reimbursements</strong>.{" "}
                        <span>
                          Any reimbursements will be processed by Stripe within
                          5 to 10 business days, subject to Stripe's terms and
                          any modification to such.{" "}
                        </span>
                      </li>
                    </ol>
                    <ol start="3" class="awlist9" type="a">
                      <li>
                        <strong>Fraud</strong>.{" "}
                        <span>
                          Customer agrees to fully indemnify, hold harmless and
                          not to sue Noddok and Company at any time and for any
                          cause of action, as well as to the extent set forth in
                          Section XIV(1) hereto, for any fraud, credit card
                          fraud, debit card fraud, identity theft, embezzlement,
                          misappropriation or any related wrongdoings stemming
                          from Customer's use of Stripe as a payment platform.
                          To the extent any surviving liability may be imposed
                          on Noddok and Company, Section XIV(2) will apply in
                          said situations.
                        </span>
                      </li>
                    </ol>
                  </Box>
                  <ol start="3">
                    <li>
                      <strong>Payment failure</strong>.{" "}
                      <span>
                        If payment of the fees processed for Plan(s) of
                        Account(s) is not successfully on the Subscription’s
                        anniversary date, Customer will have a 30-day grace
                        period to process payment, within which Noddok will
                        automatically attempt to apply the charges for fees to
                        Customer’s selected payment method on a daily basis,
                        unless changed. If payment is processed within the grace
                        period, the Pages in Customer’s current billing period
                        will be credited to the Account(s). If payment is not
                        processed within the grace period, Customer’s
                        Subscription, including all the Accounts, will be set as
                        “Inactive” under Section III(2.4) of these Terms.{" "}
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="8">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Maintenance and Downtime
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Availability; Uptime</strong>.{" "}
                      <span>
                        Customer acknowledges that due to its nature as a
                        cloud-based software accessed via the Internet, Noddok
                        may experience unscheduled downtime. Company strives to
                        keep Noddok available and accessible at all times and
                        generally avoids situations of downtime.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Maintenance and Downtime</strong>.{" "}
                      <span>
                        Company will sporadically schedule downtime for purposes
                        of maintenance, upkeep, updates or any other situation
                        that warrants downtime at Company’s sole discretion, in
                        which case Company will strive to provide Customer with
                        notice of at least 72 hours before any downtime. Company
                        is relieved from its notice obligations to Customer in
                        case of unscheduled maintenance or unexpected downtime.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="9">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Integrations with third-party platforms
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Integrations</strong>.{" "}
                      <span>
                        In addition to its own internal functionalities and
                        proprietary software, Noddok incorporates integrations
                        with third-party platforms, software, interfaces and
                        Features. Company offers said integrations based on a
                        pre-existing subscription or subscription owned or
                        purchased by Customer on said third-party platforms, and
                        thus it is not liable to the foregoing entities for any
                        obligation undertaken by Customer to such and Customer
                        shall remain solely responsible for its obligations with
                        respect to said entities. Company represents that it
                        offers integrations with said software without prejudice
                        to any intellectual property rights pertaining to the
                        aforementioned entities.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="10">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Security{" "}
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>User access</strong>.{" "}
                      <span>
                        Users are typically employees, agents, contractors, or
                        others within Customer’s organization with Customer’s
                        authorization to use their Subscription or Account(s).
                        It is Customer’s exclusive responsibility to ensure that
                        only authorized persons are registered as Users and have
                        access to the Subscription or Account(s) as well as to
                        observe security measures in accordance with Section X
                        hereto.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Subscription Management</strong>.{" "}
                      <span>
                        Customer is solely responsible for the safe management
                        of its Noddok Subscription, Accounts, Users and
                        passwords and agrees to store any Subscription
                        information in secure formats and locations so as to
                        prevent, minimize or permit the rapid attention to,
                        unauthorized access to the Subscription or Accounts.
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Security</strong>.{" "}
                      <span>
                        Noddok reinforces access controls, encrypts key
                        information and uses certified online servers, and at
                        all times will exercise reasonable care to ensure the
                        safety and accessibility of Customer’s Subscription,
                        Accounts, information and data. Customer and Company
                        will notify each other immediately upon being made aware
                        of any actual, suspected, potential, imminent or past
                        data or security breach and undertake joint steps to
                        address any such situations. Any liability that arises
                        out from, relates to or is in connection with any
                        Subscription, Account or data security breach may be
                        ultimately discharged or limited in accordance with
                        Section XIII hereto. Both Company and Customer undertake
                        to comply with its obligations under relevant applicable
                        data protection laws, statutes, principles and
                        agreements.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li>
                      <strong>Customer responsibilities</strong>.{" "}
                      <span>
                        In addition to securing the Subscription and Accounts
                        with emails and passwords, Company will ensure the
                        safety, nondisclosure and secret of all Documents and
                        Transactions inputted by Customer into Noddok. Customer
                        will undertake all necessary steps to ensure its
                        electronically stored information is safe including,
                        without limitation, having a backup of said information,
                        maintaining personal copies of the data entered into
                        Noddok, among others. Company will not be held liable
                        for any data loss.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="11">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Cancelation{" "}
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Cancelation by Customer</strong>.{" "}
                      <span>
                        Customer can cancel the Subscription at any time by
                        deactivating all the Plans in Customer’s Accounts. Once
                        all Accounts are set as “Inactive,” the Subscription
                        will be deemed canceled.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Cancelation by Company</strong>.{" "}
                      <span>
                        Company may cancel Customer’s Subscription for: (i) any
                        breach of these Terms; (ii) where permitted by the
                        Company, for any failure to remedy any such breach;
                        (iii) failure to pay the fees for Plan(s) in Account(s)
                        due in the grace period, notwithstanding Noddok’s
                        informing Customer of as much; (iv) Customer’s
                        insolvency; and (v) any other cause permitted by law.
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Surviving Sections</strong>.{" "}
                      <span>
                        Sections II(3), II(4), IV(11), VII,, XII(3), XIII, XIV
                        and XV of these Terms shall survive cancellation.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="12">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Confidential information
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Confidential Information</strong>.{" "}
                      <span>
                        Any information stored in Noddok, whether uploaded by
                        Customer or already existing in Noddok as well as any
                        information exchanged between and disclosed by Customer
                        to Company, including Documents, Transactions and
                        Content, will be regarded for purposes of these Terms as
                        confidential information (“
                        <strong>Confidential Information</strong>”) and subject
                        to the confidentiality obligations that both Customer
                        and Company undertake herein.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Use</strong>.{" "}
                      <span>
                        Both Customer and Company agree not to use any
                        Confidential Information for any purpose other than
                        Customer’s use, and Company’s provision of, Noddok.
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Confidentiality obligations</strong>.{" "}
                      <span>
                        Customer and Company agree that they shall, jointly and
                        individually, take all reasonable measures to protect
                        the secrecy of and avoid disclosure or use of
                        Confidential Information in order to prevent it from
                        falling into the public domain or the possession of
                        persons other than those persons authorized under these
                        Terms to have any such information. Such measures shall
                        include, without limitation, the highest degree of care
                        that each party utilizes to protect its own Confidential
                        Information of a similar nature, which shall be no less
                        than reasonable care. Customer and Company will notify
                        each other immediately in writing upon being made aware
                        of any actual or suspected misuse, misappropriation or
                        unauthorized disclosure of the Confidential Information.
                        If Customer is found to have incurred violations of the
                        foregoing confidentially obligations, Company will
                        immediately cancel Customer’s Subscription and
                        discontinue its use of Noddok under Section XI,
                        regardless of whether the infraction was individual,
                        isolated, repeated or systematic.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li>
                      <strong>Exceptions</strong>.{" "}
                      <span>
                        Notwithstanding the above, the parties agree that they
                        shall not have any liability with respect to each other
                        regarding any Confidential Information which either
                        party can prove: (i) was already in the public domain at
                        the time it was disclosed by either party to the other;
                        (ii) is disclosed with the prior written approval of the
                        other party; or (iii) disclosure is compelled by a
                        court, administrative agency or other governmental body,
                        in which case said disclosure will be controlled by
                        Sections XIII and XIV hereto.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="13">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Indemnity and Limitation of Liability
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Indemnification</strong>.{" "}
                      <span>
                        Customer agrees to indemnify, defend and hold Company
                        harmless, as well as its employees, contractors,
                        affiliates, executives, board and managerial officers,
                        clients, customers, shareholders and stakeholders, to
                        the fullest extent permitted by law, from and against
                        any and all harm, claims, lawsuits, causes of actions,
                        liabilities, demands, costs and expenses (inclusive of
                        attorney’s fees and costs and expenses related thereto)
                        that arise out of, or are otherwise related to, loss of
                        data, loss of profit, loss of future earnings, loss of
                        reputation, and any punitive, compensatory, incidental,
                        consequential, indirect, exemplary or reliance damages
                        thereto related caused in whole or in part by: (i) any
                        breach of these Terms by the Company, its employees,
                        contractors or agent; (ii) any gross negligence, willful
                        misconduct, fraud or material error that was solely the
                        responsibility of the Company, its employees,
                        contractors or agents; (iii) the use of misuse of Noddok
                        by Customer, their employees or affiliates that may lead
                        or effectively leads to, without limitation, financial
                        and/or tax fraud, embezzlement, mismanagement,
                        misrepresentation of accounting and financial situation,
                        illegal, illicit, inappropriate, prohibited and even
                        dishonest accounting, tax or financial practices,
                        inaccurate financial information, untimely,
                        insufficient, unreliable or erroneous financial
                        reporting, loss of earnings, loss of income, failure of
                        business model or investment, loss or corruption of
                        Customer’s data, among others.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Limitation of Liability</strong>.{" "}
                      <span>
                        Other than liability that cannot be excluded or limited
                        by law, Company’s liability to Customer arising out from
                        or related with Noddok, in contract, tort (including
                        negligence) or otherwise, the total aggregate liability
                        to Customer in any circumstance is limited to the total
                        fees Customer paid Company in the 3 months immediately
                        preceding the date on which the claim giving rise to the
                        liability arose.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="14">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Representations and Warranties
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Company’s Representations and Warranties</strong>.{" "}
                      <span>
                        Company represents and warrants: (i) it will discharge
                        its obligations pursuant to the Terms, and render all of
                        Noddok’s selected Plans and Features thereof, in a
                        competent and professional manner consistent with
                        general, reasonable industry standards; and (ii) it will
                        discharge its obligations contained herein in good
                        faith. Company intends to make no further implied
                        representations and warranties in addition to the
                        foregoing.
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Customer’s Representations and Warranties</strong>
                      .{" "}
                      <span>
                        Customer represents and warrants that: (i) it will
                        discharge its obligations pursuant to these Terms; (ii)
                        it will discharge its obligations contained herein in
                        good faith; (iii) it fully recognizes, without
                        reservation, Company’s ownership, rights, titles and
                        interests over Noddok, and does expressly forever waive
                        any right, title or interest that may be constituted in
                        its favor over Noddok; (iv) it will not use Noddok to
                        compete in any manner with Company; (v) it will not,
                        under any circumstances, furnish or provide access and
                        use credentials for the License to anyone; (vi) cannot,
                        and will not, intend to effectively reproduce, replicate
                        or copy Noddok; and (vii) it is aware that the Noddok as
                        Company’s proprietary software was fully created,
                        researched, designed, developed, maintained and executed
                        by Company at great expense, and any harm that could be
                        caused to them as a result of these Terms shall
                        constitute irreparable damage.
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Disclaimer of Warranties</strong>.{" "}
                      <span>
                        Customer’s use of Noddok at its own risk. Noddok is
                        provided on an “as is” basis. To the maximum extent
                        permitted by applicable laws, Company, its affiliates
                        and its and their third-party providers, licensors,
                        distributors or suppliers disclaim all warranties,
                        express or implied, including any warranty that Noddok
                        is fit for a particular purpose, title, merchantability,
                        data loss, non-interference with or non-infringement of
                        any intellectual property rights, or the accuracy,
                        reliability, quality of content in or linked to the
                        services. Company and its affiliates and suppliers do
                        not warrant that the services are secure, free from
                        bugs, viruses, interruption, errors, theft or
                        destruction. If the exclusions for implied warranties do
                        not apply to you, any implied warranties are limited to
                        60 days from the date of purchase or delivery of the
                        services, whichever is sooner.
                      </span>
                    </li>
                  </ol>
                </Box>
                <ol type="I" start="15">
                  <li>
                    <Typography
                      fontWeight={600}
                      sx={{ textDecoration: "underline" }}
                    >
                      Miscellaneous
                    </Typography>
                  </li>
                </ol>
                <Box ml={3}>
                  <ol>
                    <li>
                      <strong>Dispute Resolution</strong>.{" "}
                      <span>
                        Customer and Company agree that any complaints with
                        respect to Noddok will be resolved amicably between them
                        by the use of Company’s Customer Support team. Should
                        amicable resolution not be possible, Customer and
                        Company agree to resolve those disputes through binding
                        arbitration or small claims court instead of in courts
                        of general jurisdiction, without a jury.
                      </span>
                      <span>&#xa0;</span>
                      <span>
                        All disputes will be brought in the parties’ individual
                        capacity and not as a plaintiff or class member in any
                        purported class or representative proceeding.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li>
                      <strong>Governing Law and Jurisdiction</strong>.{" "}
                      <span>
                        The validity, construction and performance of this
                        Agreement shall be governed by and construed in
                        accordance with the laws of the State of Florida.
                        Customer and Company submit to the jurisdiction of the
                        competent courts of the State of Florida, and any
                        arbitration shall be seated in the State of Florida as
                        well as instructed and conducted by the institution and
                        under the rules the parties agree to. All parties must
                        bear their costs of suit and all related expenses,
                        including attorney’s fees and arbitration costs.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li>
                      <strong>Notices</strong>.{" "}
                      <span>
                        For legal notices to Company and/or Noddok, Customer
                        must direct an email to{" "}
                      </span>
					  <Link href="mailto:legal@kiiper.app" fontWeight={600}>legal@noddok.app</Link>
                      <span>
                        . For legal notices to Customer, Company will direct an
                        email to Customer’s authorized email address as provided
                        in Noddok (Owner’s profile email). Legal notices sent
                        after 5:00 p.m. E.T on a business day shall be
                        understood as received and effective as of the following
                        business day. For notices directed to all customers and
                        users of Noddok, Company may post a general legal notice
                        on (i) its website,
                      </span>
                      <span>&#xa0; </span>
                      <span>
                        or (ii) Noddok’s app, in the “Inbox” module. Customer
                        acknowledges that the foregoing practices will
                        constitute a valid notice under these Terms.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li>
                      <strong>Modifications to Terms</strong>.{" "}
                      <span>
                        Noddok may produce changes, modifications or updates to
                        these Terms at any time, in which case Company will
                        promptly notify Customer of any said changes,
                        modifications or updates. Customer will accept the new
                        terms in the way set forth in Section II(3) of the
                        Terms.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="5">
                    <li>
                      <strong>Entire agreement</strong>.{" "}
                      <span>
                        These Terms constitute the entire legally-binding
                        agreement between such parties pertaining to the subject
                        matter hereof, and merges and supersedes all prior
                        negotiations and drafts of the parties with regard to
                        the transactions contemplated herein. Any and all other
                        written or oral agreements existing between the parties
                        hereto regarding such transactions are expressly
                        canceled.
                      </span>
                    </li>
                  </ol>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Terms;